import { generateApiAction, RESPONSETYPE } from '../Generator'
import Types from '../Types'
import { listMaintenances } from '../Api'

export default generateApiAction({
  baseType: Types.MAINTENANCES.LIST,
  api: listMaintenances,
  responseType: RESPONSETYPE.DATA
})



// WEBPACK FOOTER //
// ./src/actions/maintenances/ListAction.js